import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ApiHelper } from '../../../utils/apiHelper';

export const fetchStartupProfile = createAsyncThunk(
    'profile/fetchStartupProfile',
    async (startupId, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.get(`/startup/${startupId}/profile`);
            return response.data.startupProfile;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

export const updateStartupProfile = createAsyncThunk(
    'profile/updateStartupProfile',
    async ({ startupId, profileData }, { rejectWithValue }) => {
        try {
            const response = await ApiHelper.put(`/startup/profile`, {
                startupId,
                ...profileData
            });
            if (response.data.code === "00000") {
                return profileData;
            }
            throw new Error("Failed to update profile");
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const profileSlice = createSlice({
    name: 'profile',
    initialState: {
        profile: null,
        loading: false,
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchStartupProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(fetchStartupProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.profile = action.payload;
                state.error = null;
            })
            .addCase(fetchStartupProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            })
            .addCase(updateStartupProfile.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(updateStartupProfile.fulfilled, (state, action) => {
                state.loading = false;
                state.profile = { ...state.profile, ...action.payload };
                state.error = null;
            })
            .addCase(updateStartupProfile.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export default profileSlice.reducer; 